/*
 * @Author: chengjia 645680217@qq.com
 * @Date: 2022-10-28 17:00:23
 * @LastEditors: Ning Tang
 * @LastEditTime: 2023-03-14 16:41:30
 * @FilePath: \xm\xm-runing-main\src\layouts\default\header\components\hooks\msgHooks.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import {msgStore} from '@/store/modules/msgStore';
import {useWebSocket} from '@vueuse/core'
import {axiosHelpers} from '@/api/request';
import GoingUtils from "@/utils/goingUtils";
import {useI18n} from "vue-i18n";
import {notification} from 'ant-design-vue';
import dataRelFact from '@/main-page/utils/DataRelFact';
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";

export function msgHooks(drawerVisibleComputed, selectedRecordComputed) {
  const store = msgStore()
  const {t} = useI18n();
  let origin = 'http://14.22.83.217:30026'



  if (import.meta.env.PROD) {
    origin = location.origin
    console.log(origin, "origin=========");
  }
  // origin = "http://14.22.83.217:30026"
  let token = sessionStorage.getItem('sessionId')
  let tokenData = {token: token, status: "init", type: "web"};

  const Url = new URL(`/api/pe-message/websocket/connect/web/${unref(token)}`, origin)
  // const Url = new URL(`/api/pe-message/inBoxMessage/sendWs/${unref(token)}`, origin)

  Url.protocol = Url.protocol.replace('http', 'ws')
  let msgRes = [{
    "name": "审批待办消息",
    "type": "waitHandleMessage",
    "list": []
  }, {"name": "平台通知消息", "type": "platformMessage", "list": []}, {
    "name": "通知预警",
    "type": "notificationWarning",
    "list": []
  }, {"name": "跟进消息提醒", "type": "flowMsg", "list": []}];
  const url = Url.toString()
  useWebSocket(url, {
    autoReconnect: {
      retries: 10000,
      delay: 10000,
      onFailed() {
        alert("连接失败");
        console.log('WebSocket连接失败')
      },
    },
    // Socket连接
    onConnected: (ws) => {
      //console.log(ws, event, 'Socket连接')
      ws.send(JSON.stringify(tokenData))
      // const posturl = "/pe-message/inBoxMessage/sendWs";
      // const res = axiosHelpers.postJSON(posturl, { msgData:msgRes});
      // res.then(data => {
      //     console.log(data,565656)
      // }).catch(err => {
      //     console.log(err,4646464)
      // });
    },
    // 连接异常回调
    onError(ws, event) {
      //alert("连接异常");
      console.log(ws, event, '连接异常')
    },
    // 接收消息
    onMessage(ws, event) {
      console.error(ws, event, 'Socket接收消息================')
      if(unref(store.noticeFlag)===false||unref(store.noticeFlag)==='false'){
        return;
      }
      openMsgDlg(event);
    },
    // Socket关闭
    onDisconnected(ws, event) {
      //alert("连接关闭");
      //console.log(ws, event, '连接关闭')
    },
    // 心跳
    heartbeat: {
      message: JSON.stringify({token: token, status: "health", type: "web"}),
      interval: 10000,
    }
  })

  function openMsgDlg(event) {
    if (event.data) {
      const {type} = JSON.parse(event?.data);
      //如果是心态消息
      if (type === 'heart') {
        return
      }
    }
    try {
      console.log(JSON.parse(event.data), "event.data");
      const data = JSON.parse(JSON.parse(event.data).data);
      console.log(JSON.parse(JSON.parse(event.data).data), "event.data.data");
      const content = JSON.parse(data.content);
      console.log(JSON.parse(JSON.parse(JSON.parse(event.data).data).content), "event.data.data.content");
      const dtajson = JSON.parse(data.dataJson);
      console.log(JSON.parse(JSON.parse(JSON.parse(event.data).data).dataJson), "event.data.data.dataJson");
      //GoingUtils.showMessage(t("您收到一条新信息！"));
      const message = `新消息[${content.titleContentPre}${content.msgContent}]提醒`;


      notification.open({
        message: message,
        // description: "您收到一条新信息！",
        description: h('a', {
          attrs: {
            href: 'javascript:void(0)'
          },
          style: {
            textDecoration: 'underline'
          },
          onClick: (e) => {

            //alert('查看新消息')
            const {viewModel} = useComEvent({events: []});

            if (data.inBoxType === 'waitHandleMessage') {
              if (dtajson.msgFlowType && dtajson.msgFlowType === 'simpleFlow') {
                let url = '/flowList/simplFlowDeal';
                var paramsDef = {
                  recordId: dtajson["flowId"],//"344746330700120133", //inParams['record']['flowId'],
                  tableCode: dtajson["tableCode"],//"WELD_STEEL_GRD",//inParams['record']['tableCode'],
                  formDataId: dtajson["id"],//"344746322150031429",//inParams['record']['businessKey'],
                  pageFrom: 'waitDeal'
                };
                console.log(typeof dtajson["flowId"]);
                console.log(paramsDef, 'paramsDef=================')
                url = viewModel.initUrlParams(url, paramsDef);
                viewModel.routerPath(url, paramsDef, '')
              } else {//dtajson.msgFlowType==='flow'
                let url = '/flowBpmList/flowList/simplFlowDeal';
                var paramsDef = {
                  recordId: "343257085741367365", //inParams['record']['flowId'],
                  tableCode: "MAT_ORDER_CONTROL_M",//inParams['record']['tableCode'],
                  formDataId: "344701988681809989",//inParams['record']['businessKey'],
                  pageFrom: 'waitDeal',
                  processInstanceId: "a6347b12-2a2c-11f0-890f-0242ac2300ca",//inParams['record']['processInstanceId'],
                  taskId: "b752581c-2a2c-11f0-890f-0242ac2300ca",//inParams['record']['taskId'],
                  flowType: "flowApp",//inParams['record']['flowType'],
                  nodeId: "FlowAbleActive_142i2do_ocjhfhgm_c",//inParams['record']['taskDefinitionKey'],
                  flowId: "343257085741367365",//inParams['record']['flowId'],
                  formModuleCode: "MAT_ORDER_CONTROL_MFlowDeal",//inParams['record']['formModuleCode'],
                  formPageCode: "MAT_ORDER_CONTROL_MFlowDeal",//inParams['record']['formPageCode'],
                };
                paramsDef = {
                  recordId: dtajson.flowId ? dtajson.flowId : '',
                  tableCode: dtajson.tableCode ? dtajson.tableCode : '',
                  formDataId: dtajson.businessKey ? dtajson.businessKey : '',
                  pageFrom: 'waitDeal',
                  processInstanceId: dtajson.processInstanceId ? dtajson.processInstanceId : '',
                  taskId: dtajson.taskId ? dtajson.taskId : '',
                  flowType: dtajson.flowType ? dtajson.flowType : '',
                  nodeId: dtajson.taskDefinitionKey ? dtajson.taskDefinitionKey : '',
                  flowId: dtajson.flowId ? dtajson.flowId : '',
                  formModuleCode: dtajson.formModuleCode ? dtajson.formModuleCode : '',
                  formPageCode: dtajson.formPageCode ? dtajson.formPageCode : '',
                };
                url = viewModel.initUrlParams(url, paramsDef);
                viewModel.routerPath(url, paramsDef, '')
              }
            }

            if (data.inBoxType === 'platformMessage') {
              drawerVisibleComputed.value = true;
              selectedRecordComputed.value = dtajson;
            }


          }
        }, (content.appendStr ? content.appendStr : "") + content.msgContent + (content.suffixStr ? content.suffixStr : "")),
        duration: 10, // 10秒后自动关闭
        placement: 'topRight', // 从右下角弹出
        // placement: 'bottomRight', // 从右下角弹出
        style: {
          width: '400px',
        },
        icon: "",
        btn: "",
      });
      //alert(event.data);
      store.getReadMsg()
      //store.msgDataSocketfunc(msgRes)
    } catch (error) {

    }


  }


}
